import React, { useEffect, useRef, useState } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';
import "../../css/main.css"
import { useLocation, useNavigate } from 'react-router-dom';
import { PageMenuElement } from '../elements/page_menu.js';
import { PRCInput } from '../controls/prcinput.js';
import { PRCDropDown } from '../controls/prcdropdown.js';

export function AdminViewMemberForm() {
  const location = useLocation();
  const [memberData, setMemberData] = useState([]);
  const [competencyData, setCompetencyData] = useState([]);
  const [pageData, setPageData] = useState();
  const [membershipStatus, setMembershipStatus] = useState([]);
  const [imageData, setImageData] = useState();
  const [familiesData, setFamilies] = useState([]);
  const [userLockedOut, setUserLockedOut] = useState('YES');
  const [userGroup, setUserGroup] = useState('');
  const [pseudonymData, setPseudonymData] = useState('');
  const [dateStarted, setDateStarted] = useState('');
  const [memberNotes, setMemberNotes] = useState('');
  const [supplimentaryData, setSupplimentaryData] = useState([]);
  const [cardTemplates, setCardTemplates] = useState([]);
  const [cardTemplate, setCardTemplate] = useState(-1);
  const navigate = useNavigate();
  
  let first_render = useRef(true);

  const { MakeCall } = useAPICall();



  useEffect(() => {

    if (first_render.current === true) {
      let memberID = location.state.memberID;
      LoadMemberDataForView(memberID);
      first_render.current = false;
    }

  });

  function MemberStatus() {
    let status = membershipStatus.find((element) => memberData.idpeveril_status === element.id);
    if (status) {
      return status.description;
    }
    return 'NONE';

  }

  const handleMemberDataFetchForView = (data) => {
    setPageData(data);
    setMemberData(data.components['member']);
    setCompetencyData(data.components['competencytypes']);
    setMembershipStatus(data.components['membershipstatuses']);
    setFamilies(data.components['families']);
    setPseudonymData(data.components['pseudonyms']);
    setDateStarted(new Date(data.components['member'].date_started).toLocaleDateString('en-gb', { day: "numeric", year: "numeric", month: "short" }));
    setMemberNotes(data.components["notes"]);
    setSupplimentaryData(data.components["supplimentarydata"]);
    setCardTemplates(data.components['cardtemplates']);
    let usergroupname = data.components['usergroups'].find(el => el.id === data.components['usergroup']);
    setUserGroup(usergroupname.description);

    if (data.components['user_locked_out'] === 0) {
      setUserLockedOut('NO');
    }
    LoadMemberImage(data.components['member'].idpeveril_member);
    if(data.components['cardtemplates'].length > 0)
    {
     handleTemplateChange(data.components['cardtemplates'][0].id);
    }
  }
  function handleTemplateChange(template) {
    setCardTemplate(template);
    
    sessionStorage.setItem("idtemplate", template);
  }


  function handleNav(destination, state) {
    navigate(destination, state);
  }
  function LoadMemberDataForView(id) {

    MakeCall('admin/getadminviewmemberpage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", \"idpeveril_member\" : \"" + id + "\"}", handleMemberDataFetchForView, false);
  }

  function ShowCompetencies() {
    let result = [];
    for (let i = 0; i < competencyData.length; i++) {
      const competency_item = competencyData[i];
      if (memberData.competencies.find((competency) => { if (competency.idpeveril_competency_type === competency_item.id) { return competency } return '' })) {
        result.push(<div className='formrow' key={competency_item.id} >
          <div className='formlabel'>{competency_item.description}</div>
          <div className='formvalue'>Y</div>
        </div>);
      }
      else {
        result.push(<div className='formrow' key={competency_item.id}>
          <div className='formlabel'>{competency_item.description}</div>
          <div className='formvalue'>N</div>
        </div>);
      }
    }
    return result;

  }
  function handleImageDataFetch(data) {
    setImageData(data.components['image_data']);
  }

  function LoadMemberImage(memberID) {
    const postBody = "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", " +
      "\"memberid\" : \"" + memberID + "\"}";

    MakeCall('admin/adminloadimage', postBody, handleImageDataFetch, true);
  }
  function ShowMemberImage() {
    let results = [];
    if (imageData) {
      results.push(<div><img alt='member' className='prcmemberimagesmall' src={'data:image/jpeg;base64,' + imageData} key="memberimg"></img></div>)
    }
    return results;
  }

  function onPageMenuClick(onclickname) {
    switch (onclickname) {
      case 'goback':
        //handleNav("/Admin");
        navigate(-1);
        break;
      case 'showvisits':
        handleNav("/AdminVisits", { state: { memberData: memberData } });
        break;
      case 'uploadphoto':
        handleNav("/AdminPhoto", { state: { memberData: memberData } })
        break;
      case 'editmember':
        handleNav("/EditMember", { state: { memberID: memberData.idpeveril_member } })
        break;
      case 'resetpassword':
        if (document.getElementById("changepasswordform")) {
          document.getElementById("changepasswordform").style.display = "block";
        }
        break;
      case 'addnote':
        if ( document.getElementById("addnoteform")) {
          document.getElementById("addnoteform").style.display = "block"
        }
        break;
      case 'printcard':
        if (document.getElementById("printcardform")) {
          document.getElementById("printcardform").style.display = "block";
        }
        break;     
       
      default:
        break;

    }
  }


  function ShowFamily(idpeveril_family) {
    let family = familiesData.find(el => el.id === idpeveril_family);
    if (family) {
      return family.description;
    }
    else {
      return ('NONE');
    }
  }

  function handleSavePasswordComplete(data) {
    if (data.components['result'].succeeded === true) {
      document.getElementById("changepasswordform").style.display = "none";
    }
  }
  function handleSaveNewPassword() {
    const postBody = "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", " +
      "\"idpeveril_member\" : \"" + memberData.idpeveril_member + "\"," +
      "\"password\":\"" + document.getElementById('password').value + "\"}";

    MakeCall('admin/changepassword', postBody, handleSavePasswordComplete, true);
  }
  function handleSaveNoteComplete(data) {
    if (data.components['result'].succeeded === true) {
      document.getElementById("addnoteform").style.display = "none";
      MakeCall('admin/getadminviewmemberpage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", \"idpeveril_member\" : \"" + memberData.idpeveril_member + "\"}", handleMemberDataFetchForView, true);
      
    }

  }

  function base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
       var ascii = binaryString.charCodeAt(i);
       bytes[i] = ascii;
    }
    return bytes;
 }

  function handlePrintCardComplete(data) {
    if (data.components['cardresult'].result === true) {
      var carddata = data.components['cardresult'].carddata;
       var blob = new Blob([base64ToArrayBuffer(carddata)], {type: "application/pdf"});
       var link = document.createElement('a');
       link.href = window.URL.createObjectURL(blob);
    
       link.download = data.components['cardresult'].filename;
       link.click();
    }
    document.getElementById("printcardform").style.display = "none"

  }
function handlePrintCard()
{
  var cardexpiry = document.getElementById("cardexpiry").value;

  const postBody = "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", " +
  "\"idpeveril_member\" : \"" + memberData.idpeveril_member + "\"," +
  "\"idtemplate\":\"" + cardTemplate + "\"," +
  "\"cardexpiry\":\"" + cardexpiry +  "\"}";
  MakeCall('admin/printcard', postBody, handlePrintCardComplete, true);
}

  function handleSaveNote()
  {
    const postBody = "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", " +
      "\"idpeveril_member\" : \"" + memberData.idpeveril_member + "\"," +
      "\"note\":\"" + document.getElementById('membernote').value + "\"}";

    MakeCall('admin/addnote', postBody, handleSaveNoteComplete, true);
  }

  function ShowChangePasword() {

    return (
      <div className='popup_form' id="changepasswordform">
        <h1>Change user password</h1>
        <div className='formrow' style={{ "paddingBottom": "1em" }}>
          <div className='formlabel' style={{ "width": "30%" }}>
            New Password
          </div>
          <div className='formvalue'>
            <PRCInput id='password' className='logininput' />
          </div>
        </div>

        <div className='formrowcentered'>

          <div className='formlabel'>
            <input type='button' className='prcbtn' value='Save' onClick={handleSaveNewPassword} />
          </div>
          <div className='formlabel'>
            <input type='button' className='prcbtn' value='Cancel' onClick={() => { document.getElementById("changepasswordform").style.display = "none" }} />
          </div>
        </div>
      </div>);

  }


  function ShowPseudonyms() {
    let result = [];

    if (pseudonymData.length > 0) {
      result.push(<div style={{ "height": "1em" }} />);
      result.push(<div className='formtitle'>Pseudonyms</div>);
      for (let i = 0; i < pseudonymData.length; i++) {
        result.push(<div className='gridrow' key={pseudonymData[i].idpeveril_member_pseudonym}>
          <div className='gridcell' style={{ "width": "100%" }}>{pseudonymData[i].pseudonym}</div>
        </div>);
      }

    }

    return result;
  }

  function ShowMemberNotes()
  {

    let result = [];

    if (memberNotes.length > 0) {
      result.push(<div style={{ "height": "1em" }} />);
      result.push(<div className='formtitle'>Notes</div>);
      for (let i = 0; i < memberNotes.length; i++) {
        let date_added = new Date(memberNotes[i].date_added).toLocaleDateString('en-gb', { day: "numeric", year: "numeric", month: "short" });
        result.push(<div className='gridrow' key={"notes" + i}>
          <div className='gridcell' style={{ "width": "30%" }}>{date_added}</div>
          <div className='gridcell' style={{ "width": "70%" }}>{memberNotes[i].note}</div>
        </div>);
      }

    }
    return result;
  }

function ShowAddNote()
{
  return (
    <div className='popup_form' id="addnoteform">
      <h1>Add Note</h1>
      <div className='formrow' style={{ "paddingBottom": "1em" }}>
        <div className='formlabel' style={{ "width": "30%" }}>
          Note
        </div>
        <div className='formvalue' width = '70%'>
          <PRCInput id='membernote' className='logininput' />
        </div>
      </div>

      <div className='formrowcentered'>

        <div className='formlabel'>
          <input type='button' className='prcbtn' value='Save' onClick={handleSaveNote} />
        </div>
        <div className='formlabel'>
          <input type='button' className='prcbtn' value='Cancel' onClick={() => { document.getElementById("addnoteform").style.display = "none" }} />
        </div>
      </div>
    </div>);
}

function ShowSupplimentaryData()
{
  let result = [];
  if(supplimentaryData != null)
  {
  if (supplimentaryData.length > 0) {
   
    for (let i = 0; i < supplimentaryData.length; i++) {
      result.push(<div className='formrow' key={supplimentaryData[i].supplimentary_data_name} >
      <div className='formlabel'>{supplimentaryData[i].supplimentary_data_name}</div>
      <div className='formvalue'>{supplimentaryData[i].data_value}</div>
      </div>);
    }
    
  }
  }

  return result;
}

function ShowPrintCard() {
  
      return (
          <div className='popup_form' id="printcardform">
              <h1>Print Membership Card</h1>              
              <div className='formrow' >
                  <div className='formlabel' style={{ "width": "30%" }}>
                      Card Template
                  </div>
                  <div className='formvalue'>
                  <PRCDropDown id='peverilCardTemplate' className='logininput' name='CARD_TEMPLATE' placeholder="Card Template" 
                  options={cardTemplates} value={cardTemplate} onChange={handleTemplateChange} /> 
                  </div>                  
              </div>
              <div className='formrow'>
                  <div className='formlabel' style={{ "width": "30%" }}>
                      Expiry
                  </div>
                  <div className='formvalue'>
                     <PRCInput id='cardexpiry' className='logininput' />
                  </div>                  
              </div>
              <div className='formrowcentered'  style={{"width":"100%"}}>              
              <div className='formlabel'>
                <input type='button' className='prcbtn' value='Print' onClick={handlePrintCard} />
              </div>
              <div className='formlabel'>
                <input type='button' className='prcbtn' value='Cancel' onClick={() => { document.getElementById("printcardform").style.display = "none" }} />
              </div>    
              </div>
          </div>);
  
}


  return (

    <div>

      {SecurityElement(pageData)}
      {MenuForm()}
      {ShowChangePasword()}
      {ShowPrintCard()}
      {ShowAddNote()}
      <div className="contentdiv">
        {PageMenuElement("View Member", [{ "name": "Back", "onclick": "goback" },
        { "name": "Show Visits", "onclick": "showvisits", "permission_name": "ViewAdmin" },
        { "name": "Upload Photo", "onclick": "uploadphoto", "permission_name": "UpdateMember" },
        { "name": "Edit Member", "onclick": "editmember", "permission_name": "UpdateMember" },
        { "name": "Reset Password", "onclick": "resetpassword", "permission_name": "UpdateMember" },
        { "name": "Add Note", "onclick": "addnote", "permission_name": "ViewAdmin" },
        { "name": "Print Card", "onclick": "printcard", "permission_name": "UpdateMember" }], onPageMenuClick)}
        <div id='AdminViewMember' >

          <div className='formbox'>
            <div className='formtitle'>Details : {memberData.forename} {memberData.surname}</div>
            <div className='colspan'>
              <div style={{"width":"80%"}}>
                <div className='formrow'>
                  <div className='formlabel' >Status</div>
                  <div className='formvalue'>{MemberStatus()}</div>
                </div>
                <div className='formrow'>
                  <div className='formlabel'>Number</div>
                  <div className='formvalue'>{memberData.membership_number}</div>
                </div>
                <div className='formrow'>
                  <div className='formlabel'>Type</div>
                  <div className='formvalue'>{memberData.peveril_membership_type}</div>
                </div>
                <div className='formrow'>
                  <div className='formlabel'>Forename</div>
                  <div className='formvalue'>{memberData.forename}</div>
                </div>
                <div className='formrow'>
                  <div className='formlabel'>Surname</div>
                  <div className='formvalue'>{memberData.surname}</div>
                </div>
                <div className='formrow'>
                  <div className='formlabel'>Family</div>
                  <div className='formvalue'>{ShowFamily(memberData.idpeveril_family)}</div>
                </div>
                <div className='formrow'>
                  <div className='formlabel'>Date Started</div>
                  <div className='formvalue'>{dateStarted}</div>
                </div>
              </div>
              <div style={{ "display": "flex", "width": "20%" }}>
                <div style={{ "display": "flex", "width": "100%", "alignContent": "right", "justifyContent": "end" }} >{ShowMemberImage()}</div>
              </div>
            </div>
            {ShowMemberNotes()}
            {ShowPseudonyms()}
            
          </div>
          
          
          <div className='formbox'>
            <div className='formtitle'>
              Contact Details
            </div>
            <div className='formrow'>
              <div className='formlabel'>Email</div>
              <div className='formvalue'>{memberData.email}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>User Type</div>
              <div className='formvalue'>{userGroup}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>User Locked Out</div>
              <div className='formvalue'>{userLockedOut}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>Mobile</div>
              <div className='formvalue'>{memberData.mobile_number}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>Home</div>
              <div className='formvalue'>{memberData.fixed_line_number}</div>
            </div>
          </div>
          <div className='formbox'>
            <div className='formtitle'>
              Supplementary Info
            </div>          
          {ShowSupplimentaryData()}
          </div>
          <div className='formbox'>
            <div className='formtitle'>
              Address
            </div>
            <div className='formrow'>
              <div className='formlabel'>House / Number</div>
              <div className='formvalue'>{memberData.house}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>Street</div>
              <div className='formvalue'>{memberData.street}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>Area</div>
              <div className='formvalue'>{memberData.area}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>Town</div>
              <div className='formvalue'>{memberData.town}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>Country</div>
              <div className='formvalue'>{memberData.country}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>Postcode</div>
              <div className='formvalue'>{memberData.postcode}</div>
            </div>
          </div>  
          <div className='formbox'>
            <div className='formtitle'>
              Competencies
            </div>
            {ShowCompetencies()}
          </div>

        </div>
        <div>

        </div>
      </div>

    </div>


  );
}
